// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"31a01326","977":"dfe030bd"}[chunkId] + ".chunk.js";
};